import './LayoutBreadcrumbItem.scss';
import { LocationDescriptor } from 'history';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  to: LocationDescriptor;
};

export const LayoutBreadcrumbItem = memo(({ children, to }: Props) => (
  <Link to={to} className="bp-layout-breadcrumb-item">
    {children}
  </Link>
));
